var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 390,
    viewBox: "0 0 540 390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M556.719 89.2881L463.37 -39.8899",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.708 -106.606L556.898 88.2119",
    stroke: "url(#paint0_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.898 88.1533L372.274 -92.8628",
    stroke: "url(#paint1_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.392 44.8152C482.147 44.7512 481.19 43.6817 481.254 42.4239C481.319 41.167 482.381 40.1999 483.626 40.2639C484.871 40.328 485.829 41.3985 485.764 42.6553C485.699 43.9131 484.637 44.8793 483.392 44.8152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.837 131.919C500.592 131.857 499.635 130.785 499.7 129.528C499.765 128.271 500.826 127.304 502.072 127.367C503.317 127.432 504.274 128.502 504.209 129.759C504.144 131.017 503.082 131.983 501.837 131.919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.478 246.682C503.232 246.618 502.276 245.548 502.341 244.291C502.405 243.034 503.467 242.068 504.713 242.131C505.958 242.195 506.914 243.266 506.85 244.522C506.785 245.779 505.723 246.746 504.478 246.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.603 383.997C521.357 383.933 520.4 382.862 520.465 381.606C520.53 380.349 521.592 379.382 522.836 379.446C524.082 379.509 525.04 380.579 524.975 381.837C524.91 383.093 523.848 384.061 522.603 383.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.421 353.344L504.658 244.407",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.599 244.425L522.719 381.702",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.719 381.581L388.475 353.483",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.415 382.795L647.492 431.232",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.722 381.755L556.219 512.98",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.669 381.72L593.423 281.369",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.375 281.273L504.605 244.502",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.685 209.478L504.586 244.407",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.513 244.407L598.619 80.5934",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.99 -3.03467L483.938 42.8528",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.963 42.9759L598.719 84.6807",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.561 80.5936L501.931 129.645",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.959 129.646L504.602 244.405",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.749 381.721L475.987 440.691",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.891 42.8533L586.741 -89.7285",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.587 353.402L581.217 343.174",
    stroke: "url(#paint2_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.263 343.174L497.815 460.134",
    stroke: "url(#paint3_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.422 474.282L313.257 299.82",
    stroke: "url(#paint4_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.666 386.195L190.458 458.06",
    stroke: "url(#paint5_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.914 9.80999L315.034 297.358",
    stroke: "url(#paint6_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.207 236.891L389.541 353.402",
    stroke: "url(#paint7_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.497 353.402L546.008 146.755",
    stroke: "url(#paint8_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.922 146.742L528.267 53.9287",
    stroke: "url(#paint9_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.183 12.4292L528.247 53.915",
    stroke: "url(#paint10_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.246 357.672C385.878 357.551 384.06 355.513 384.183 353.123C384.306 350.732 386.324 348.894 388.693 349.016C391.06 349.138 392.879 351.174 392.757 353.564C392.634 355.955 390.614 357.793 388.246 357.672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.043 58.2437C525.675 58.1222 523.856 56.085 523.979 53.6944C524.103 51.3057 526.122 49.4665 528.49 49.588C530.857 49.7095 532.676 51.7447 532.554 54.1353C532.43 56.526 530.412 58.3642 528.043 58.2437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.367 485.514L460.643 363.232",
    stroke: "url(#paint11_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.645 363.282L536.914 455.899",
    stroke: "url(#paint12_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.875 455.959L598.437 381.233",
    stroke: "url(#paint13_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.179 275.414L460.608 363.223",
    stroke: "url(#paint14_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.641 363.323L598.406 381.133",
    stroke: "url(#paint15_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.406 184.47L493.139 183.3",
    stroke: "url(#paint16_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.14 183.286L546.141 275.373",
    stroke: "url(#paint17_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.141 275.331L432.763 259.588",
    stroke: "url(#paint18_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.758 259.526L460.641 363.201",
    stroke: "url(#paint19_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.703 363.223L252.813 497.293",
    stroke: "url(#paint20_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.767 497.293L432.865 259.505",
    stroke: "url(#paint21_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.758 259.49L412.443 152.69",
    stroke: "url(#paint22_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.728 259.506L493.172 183.245",
    stroke: "url(#paint23_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.101 183.244L502.114 104.937",
    stroke: "url(#paint24_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.079 104.936L555.763 87.2471",
    stroke: "url(#paint25_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.75 87.1826L472.747 29.6275",
    stroke: "url(#paint26_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.719 29.5623L600.461 -42.6021",
    stroke: "url(#paint27_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.753 29.5855L502.086 104.914",
    stroke: "url(#paint28_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.108 104.937L412.427 152.674",
    stroke: "url(#paint29_radial_15773_20480)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.132 304.438C310.781 305.01 307.994 302.234 308.345 298.985C308.596 296.639 310.537 294.731 312.867 294.554C316.187 294.306 318.799 297.316 318.071 300.636C317.649 302.569 316.065 304.109 314.132 304.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.184 157.654C409.46 157.514 407.366 155.171 407.509 152.42C407.65 149.671 409.974 147.555 412.698 147.696C415.422 147.835 417.516 150.178 417.374 152.928C417.232 155.679 414.908 157.795 412.184 157.654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.504 264.485C429.78 264.344 427.687 262.001 427.827 259.25C427.97 256.5 430.293 254.385 433.016 254.524C435.741 254.665 437.836 257.009 437.695 259.758C437.551 262.508 435.229 264.625 432.504 264.485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.825 109.916C499.101 109.775 497.007 107.432 497.149 104.682C497.291 101.932 499.615 99.8155 502.337 99.9554C505.062 100.096 507.156 102.44 507.015 105.189C506.873 107.94 504.549 110.056 501.825 109.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.88 188.224C490.157 188.085 488.062 185.74 488.206 182.99C488.347 180.24 490.67 178.124 493.394 178.265C496.119 178.405 498.213 180.747 498.069 183.497C497.929 186.249 495.605 188.365 492.88 188.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.49 34.5431C469.765 34.4022 467.672 32.0596 467.813 29.3077C467.956 26.5577 470.278 24.4434 473.002 24.5833C475.727 24.7232 477.821 27.0667 477.679 29.8167C477.539 32.5656 475.214 34.684 472.49 34.5431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.387 368.201C457.665 368.062 455.57 365.72 455.712 362.969C455.854 360.218 458.177 358.102 460.901 358.242C463.626 358.383 465.719 360.726 465.578 363.477C465.436 366.227 463.113 368.342 460.387 368.201Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(510.303 -9.1971) rotate(9.78425) scale(75.9785 76.6784)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.586 -2.35476) rotate(9.7851) scale(91.2133 92.0617)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(485.402 348.288) rotate(92.9937) scale(67.655 67.8755)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(539.539 401.654) rotate(92.9532) scale(51.0914 50.6142)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(502.339 387.051) rotate(92.9553) scale(148.494 147.205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(441.062 422.127) rotate(92.9669) scale(179.936 179.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(522.974 153.584) rotate(92.9541) scale(179.932 178.301)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(479.874 295.146) rotate(92.9543) scale(76.6165 75.9269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(467.753 250.079) rotate(92.9532) scale(92.0772 91.2172)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(537.095 100.336) rotate(92.9576) scale(33.504 33.2355)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(567.215 33.1721) rotate(92.9549) scale(31.5699 31.2923)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(467.005 424.373) rotate(92.9641) scale(43.5319 43.269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(498.78 409.591) rotate(92.9532) scale(42.7832 42.3838)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(567.656 418.596) rotate(92.9532) scale(34.5102 34.1881)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(503.393 319.318) rotate(92.9534) scale(43.6957 43.2896)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(529.524 372.228) rotate(92.966) scale(49.4057 49.141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(553.273 183.885) rotate(93.0206) scale(42.0478 42.5341)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(519.64 229.329) rotate(92.9534) scale(37.8357 37.4839)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(489.451 267.459) rotate(92.965) scale(40.731 40.5008)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(446.699 311.364) rotate(92.9555) scale(38.0977 37.7681)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(356.758 430.258) rotate(92.9543) scale(88.1373 87.3439)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(342.816 378.399) rotate(92.9532) scale(105.928 104.939)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(422.6 206.09) rotate(92.9576) scale(38.5401 38.2313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(462.95 221.375) rotate(92.9532) scale(34.6767 34.353)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(497.608 144.09) rotate(92.9608) scale(27.8916 27.6947)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(528.921 96.0919) rotate(92.9575) scale(20.2399 20.0783)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(514.249 58.4053) rotate(92.9539) scale(36.1105 35.7818)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(536.59 -6.51978) rotate(92.9547) scale(52.3546 51.8905)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(487.419 67.2499) rotate(92.9541) scale(28.7614 28.5004)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_15773_20480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(457.268 128.806) rotate(92.9549) scale(36.304 35.9847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects);
export default __webpack_public_path__ + "static/media/Objects.c5ad7f06accdc901ffa83be2f01623f0.svg";
export { ForwardRef as ReactComponent };